<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="funcRoute(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>
    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' m-2'">
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow class="m-1" align-horizontal="center" align-vertical="center">
          <CCol xl="6" lg="6" md="12" sm="12">
            <div v-if="Type === 'audio'">
              <CRow class alignHorizontal="center" alignVertical="center">
                <div
                  class="containerIconAudio"
                  @click.prevent="playSound(soundOBJ)"
                >
                  <font-awesome-icon icon="volume-up" class="IconClose" />
                </div>
              </CRow>
            </div>

            <div v-else-if="Type === 'text'">
              <template v-if="dataQuiestion[1] === 'CN'">
                <CRow alignHorizontal="center" alignVertical="center">
                  <div class="p-4">
                    <template v-if="dataQuiestion[0]?.length <= 1">
                      <h1 class="fontChinese" style="font-size: 90px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length <= 5">
                      <h1 class="fontChinese" style="font-size: 70px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length > 5">
                      <h1 class="fontChinese" style="font-size: 30px">
                        {{ dataQuiestion[0] }}
                      </h1>
                      <template
                        v-if="
                          dataQuiestion[2] !== null ||
                          dataQuiestion[2] !== undefined ||
                          dataQuiestion[2] !== ''
                        "
                      >
                        <h1 class="" style="font-size: 30px">
                          {{ dataQuiestion[2] }}
                        </h1>
                      </template>
                    </template>
                  </div>
                </CRow>
              </template>
              <template v-else-if="dataQuiestion[1] === 'PIN IN'">
                <CRow alignHorizontal="center" alignVertical="center">
                  <div class="p-4">
                    <template v-if="dataQuiestion[0]?.length <= 1">
                      <h1 class="fontPinyin" style="font-size: 90px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length <= 5">
                      <h1 class="fontPinyin" style="font-size: 70px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length > 5">
                      <h1 class="fontPinyin" style="font-size: 30px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                  </div>
                </CRow>
              </template>
              <template v-else>
                <CRow alignHorizontal="center" alignVertical="center">
                  <div class="p-4">
                    <template v-if="dataQuiestion[0]?.length <= 1">
                      <h1 class="fontPinin" style="font-size: 90px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length <= 5">
                      <h1 class="fontPinin" style="font-size: 30px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                    <template v-else-if="dataQuiestion[0]?.length > 5">
                      <h1 class="fontPinin" style="font-size: 30px">
                        {{ dataQuiestion[0] }}
                      </h1>
                    </template>
                  </div>
                </CRow>
              </template>
            </div>

            <div v-else-if="Type === 'image'">
              <CRow alignHorizontal="center" alignVertical="center">
                <div>
                  <img
                    :src="
                      baseUrl +
                      cardContent?.content?.question[0]?.item[0]?.item?.data
                    "
                    class="fontPinin"
                    style="width: 100%"
                  />
                </div>
              </CRow>
            </div>
          </CCol>

          <CCol
            xl="6"
            lg="6"
            md="12"
            sm="12"
            style="display: flex; justify-content: center"
          >
            <CRow class="img-container" style="padding: 0% 5% 5% 5%">
              <template v-if="AnswerType === 'image'">
                <CCol
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  v-for="(data, index) in AnswerChoice"
                  alignHorizontal="center"
                  alignVertical="center"
                  :key="index"
                  style="padding: 5% 1% 1% 0"
                >
                  <div
                    class="CardSelectCustom"
                    :id="index"
                    alignVertical="center"
                    @click="selectItem(index, data.choice.choices.item.data)"
                    alignHorizontal="center"
                  >
                    <!-- <h2>ใส่รูป</h2> -->
                    <img
                      :src="baseUrl + data.choice.choices.item.data"
                      class="fontPinin"
                      style="width: 100%"
                    />
                  </div>
                </CCol>
              </template>
              <template v-else>
                <CCol
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  v-for="(data, index) in AnswerChoice"
                  alignHorizontal="center"
                  alignVertical="center"
                  :key="index"
                  style="padding: 5% 0 0 0"
                >
                  <template v-if="data.choice.choices.item.comment === 'CN'">
                    <template v-if="AnswerType === 'image'">
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>ใส่รูป</h2> -->
                        <img
                          :src="baseUrl + data.choice.choices.item.data"
                          class="fontPinin"
                          style="width: 100%"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>{{data.data}}</h2> -->
                        <h2 class="mb-0 info-desc fontChinese">
                          {{
                            checkLanguageAndText(
                              data.choice.choices.item.data,
                              'main'
                            )
                          }}
                        </h2>
                        <h7 class="mb-0 info-desc">{{
                          checkLanguageAndText(
                            data.choice.choices.item.data,
                            'sub'
                          )
                        }}</h7>
                      </div>
                    </template>
                  </template>
                  <template
                    v-else-if="data.choice.choices.item.comment === 'PIN IN'"
                  >
                    <template v-if="AnswerType === 'image'">
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>ใส่รูป</h2> -->
                        <img
                          :src="baseUrl + data.choice.choices.item.data"
                          class="fontPinin"
                          style="width: 100%"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>{{data.data}}</h2> -->
                        <h2 class="mb-0 info-desc fontPinyin">
                          {{
                            checkLanguageAndText(
                              data.choice.choices.item.data,
                              'main'
                            )
                          }}
                        </h2>
                        <h7 class="mb-0 info-desc">{{
                          checkLanguageAndText(
                            data.choice.choices.item.data,
                            'sub'
                          )
                        }}</h7>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="AnswerType === 'image'">
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>ใส่รูป</h2> -->
                        <img
                          :src="baseUrl + data.choice.choices.item.data"
                          class="fontPinin"
                          style="width: 100%"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="CardSelectCustom"
                        :id="index"
                        @click="
                          selectItem(index, data.choice.choices.item.data)
                        "
                      >
                        <!-- <h2>{{data.data}}</h2> -->
                        <h2 class="mb-0 info-desc">
                          {{
                            checkLanguageAndText(
                              data.choice.choices.item.data,
                              'main'
                            )
                          }}
                        </h2>
                        <h7 class="mb-0 info-desc">{{
                          checkLanguageAndText(
                            data.choice.choices.item.data,
                            'sub'
                          )
                        }}</h7>
                      </div>
                    </template>
                  </template>
                </CCol>
              </template>
            </CRow>
          </CCol>
        </CRow>

        <template v-if="cardType == 'test'">
          <CRow alignHorizontal="center">
            <CButton
              :color="getNextButtonColor"
              shape="pill"
              size="lg"
              class="ml-2 mr-2 mt-5 pl-5 pr-5 pt-3 pb-3"
              @click="nextTo()"
              >NEXT</CButton
            >
          </CRow>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  components: {},
  name: 'CardSelection',
  props: {
    cardType: String,
    CardPopupImg: Object,
    cardContent: Object,
    getNextButtonColor: String,
    Type: String,
    AnswerType: String,
    soundOBJ: HTMLAudioElement,
    initialAnswer: Array,
    AnswerChoice: Array,
  },
  data() {
    return {
      dataQuiestion: '',
      answer: [],
      sound: this.cardContent.sound,
      soundPath: '',
      lang: this.$store.getters['language/getLanguage'],
      countQ: 1,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      answerCount: 0,
      multiAnswer: '',
    };
  },

  computed: {
    ...mapGetters({
      getLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    cardContent() {
      this.setData();
    },
    getLanguage: function (val) {
      this.lang = val;
    },
    // answerCount(value) {},
  },

  mounted() {
    this.setData();
  },

  created() {
    this.lang = this.$store.getters['language/getLanguage'];
  },

  beforeDestroy() {},
  methods: {
    setData() {
      this.unActiveSelected();
      if (this.cardType === 'assignment') {
        this.$emit('setIsNextButtonActive', false);
      } else {
        this.$emit('setIsSubmitButtonAttribute', false);
      }

      const data =
        this.cardContent?.content?.question?.[0]?.item?.[0]?.item?.data;

      if (data) {
        this.dataQuiestion = data.split('#');
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    checkLanguageAndText(val, type) {
      if (val) {
        let str = val.split('(');
        if (str.length > 1) {
          if (type == 'main') {
            return str[0];
          } else if (type == 'sub') {
            return '(' + str[1];
          }
        } else {
          if (type == 'main') {
            return val;
          } else if (type == 'sub') {
            return '';
          }
        }
      } else {
      }
    },
    funcRoute(tempId) {
      //Card selection
      if (tempId === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        //exit
        const str = tempId.split('-');
        this.$router.push(`/v4/${str[0]}/${str[1]}`);
      }
    },

    playSound() {
      let audio = this.soundOBJ;
      if (this.soundOBJ) {
        audio.pause();
        audio.play();
      }
    },
    nextTo() {
      console.log('run nextto');

      if (this.getNextButtonColor == 'success') {
        this.$emit('getSubmitButtonAttribute', true);
      } else {
        alert('Please complete the test');
      }
    },
    selectItem(id, data) {
      var checkMulti = this.cardContent.content.question[0].multiSelect;

      let item = document.getElementById(id);
      let ItemChild = item.children[0];

      if (checkMulti == true) {
        if (item.className == 'CardSelectCustom') {
          this.answerCount = this.answerCount + 1;
          this.addTheAnswer(data, item, ItemChild);
          item.classList.remove('CardSelectCustom');
          item.classList.add('CardSelectCustom-active');
        } else {
          this.answerCount = this.answerCount - 1;
          item.classList.remove('CardSelectCustom-active');
          item.classList.add('CardSelectCustom');
          this.removeTheAnswer(data, item, ItemChild);
        }
        this.$emit('selectedAns', this.initialAnswer);
      } else {
        this.$emit('selectedAns', data);
        this.unActiveSelected();
        item.classList.add('CardSelectCustom-active');
        item.classList.remove('CardSelectCustom');
        if (this.cardType === 'test') {
          this.$emit('setIsSubmitButtonAttribute', true);
        } else if (this.cardType === 'assignment') {
          this.$emit('setIsNextButtonActive', true);
        }
      }
    },

    removeTheAnswer(value, selectedItem, selectedItemChild) {
      let ax = this.initialAnswer.indexOf(value);
      this.initialAnswer.splice(ax, 1, '');
    },
    clearTheAnswer(val) {
      this.answerCount = 1;
      let allSelected = document.getElementsByClassName('matrix');
      for (let item in this.initialAnswer) {
        this.initialAnswer.splice(item, 1, '');
        this.unActiveSelected();
      }
      for (var loops of this.answer) {
        this.unActiveSelected();
      }
      this.initialAnswer.splice(0, 1, val);
    },
    unActiveSelected() {
      // this.answer = [];
      let selected = document.getElementsByClassName('CardSelectCustom-active');
      for (let x of selected) {
        x.classList.add('CardSelectCustom');
        x.classList.remove('CardSelectCustom-active');
      }
    },
    addTheAnswer(value, selectedItem, selectedItemChild) {
      if (this.initialAnswer.length < this.answerCount) {
        this.clearTheAnswer(value);
      } else {
        if (
          this.initialAnswer[0] !== '' &&
          this.initialAnswer[1] == '' &&
          this.initialAnswer[2] !== ''
        ) {
          let ax = this.initialAnswer.indexOf('');
          this.initialAnswer.splice(ax, 1, value);
        } else {
          this.initialAnswer.splice(this.answerCount - 1, 1, value);
        }
      }
    },
  },
};
</script>

<style>
.img-container {
  background-color: #ebebeb;
  width: 100%;
  height: 100%;
  font-size: 80px;
  border-radius: 10px;
}
.CardSelectCustom {
  width: 100%;
  height: 100%;
  /* margin-bottom: 4rem; */
  background-color: #fefefe;
  /* margin-bottom: 1rem; */
  border-radius: 15px;
  /* cursor: not-allowed; */
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.CardSelectCustom-active {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  /* padding-top: 5%; */
  /* justify-content: center;
  border-radius: 15px;
  margin-bottom: 0rem !important; */
  background-color: #84d19b;
  border: 5px solid #457ae6;
}
.CardSelectCustom-2c {
  width: 100% !important;
  height: 10rem !important;
  margin-bottom: 4px !important;
  /* background-color: #fefefe; */
  border-radius: 15px !important;
}
.CardSelectCustom-3c {
  width: 100%;
  height: 80%;
  margin-bottom: 2.5rem;
  background-color: #fefefe;
  border-radius: 15px;
}
.info-desc {
  text-align: center;
  padding-bottom: 2rem;
  padding-top: 2rem;
  /* font-size: 40px; */
}
</style>
